// removed by extract-text-webpack-plugin
module.exports = {"myMenu":"_3kIOQEMzX6426RodDirGjr","active":"_2fa8zeFziQIodI7Y2ojb2b","avar":"_16LHTGUV6gb-kRdXd-ilxl","blink":"_34jzny1YKWR5jhvmG7uNTr"};


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/Menu/style.css
// module id = 295
// module chunks = 0